import _ from 'lodash'


const initialState = {
  loading: false,
  immobilizer: {
    request_sent: false,
    code_data: null
  },
  pats: {
    request_sent: false,
    code_data: null
  },
  error: {}
}

const SecurityCodeTypes = {
  immobilizer: 3,
  pats: 2
}

const manufacturer_code = 'MA'
const transaction_flag = {
  dealer: 1
}

export const GET_IMMOBILIZER_CODE = 'GET_IMMOBILIZER_CODE'
export const GET_IMMOBILIZER_CODE_SUCCESS = 'GET_IMMOBILIZER_CODE_SUCCESS'
export const GET_IMMOBILIZER_CODE_ERROR = 'GET_IMMOBILIZER_CODE_ERROR'

export const GET_PATS_CODE = 'GET_PATS_CODE'
export const GET_PATS_CODE_SUCCESS = 'GET_PATS_CODE_SUCCESS'
export const GET_PATS_CODE_ERROR = 'GET_PATS_CODE_ERROR'

export const RESET_SENT_REQUEST = 'RESET_SENT_REQUEST'

export const getImmobilizerCode = data => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_IMMOBILIZER_CODE })
  return getSecurityCode(httpRequest, data, SecurityCodeTypes['immobilizer'])
    .then(response => {
      dispatch({
        type: GET_IMMOBILIZER_CODE_SUCCESS,
        code_data: response.data
      })
      return Promise.resolve(response.data)
    })
    .catch(error => {
      dispatch({
        type: GET_IMMOBILIZER_CODE_ERROR,
        error: _.get(error, 'response.data[0]')
      })
      return Promise.reject(error)
    })
}

export const getPATSCode = data => (dispatch, getState, { httpRequest }) => {
  dispatch({ type: GET_PATS_CODE })
  return getSecurityCode(httpRequest, data, SecurityCodeTypes['pats'])
    .then(response => {
      dispatch({
        type: GET_PATS_CODE_SUCCESS,
        code_data: response.data
      })
      return Promise.resolve(response.data)
    })
    .catch(error => {
      dispatch({
        type: GET_PATS_CODE_ERROR,
        error: _.get(error, 'response.data[0]')
      })
      return Promise.reject(error)
    })
}

function getSecurityCode(httpRequest, data, type) {
  return httpRequest.post('/security-code', {
    transaction_type: type,
    manufacturer_code,
    transaction_flag: transaction_flag['dealer'],
    ...data
  })
}

export const resetSentRequest = () => dispatch => dispatch({ type: RESET_SENT_REQUEST })

const ACTION_HANDLERS = {
  [GET_IMMOBILIZER_CODE]: state => ({
    ...state,
    loading: true
  }),
  [GET_PATS_CODE]: state => ({
    ...state,
    loading: true
  }),
  [GET_IMMOBILIZER_CODE_SUCCESS]: (state, { code_data }) => ({
    ...state,
    immobilizer: {
      request_sent: true,
      code_data: code_data
    },
    loading: false
  }),
  [GET_PATS_CODE_SUCCESS]: (state, { code_data }) => ({
    ...state,
    pats: {
      request_sent: true,
      code_data: code_data
    },
    loading: false
  }),
  [GET_IMMOBILIZER_CODE_ERROR]: (state, { error }) => ({
    ...state,
    error: error,
    loading: false
  }),
  [GET_PATS_CODE_ERROR]: (state, { error }) => ({
    ...state,
    error: error,
    loading: false
  }),
  [RESET_SENT_REQUEST]: state => ({
    ...state,
    immobilizer: {
      request_sent: false,
      code_data: null
    },
    pats: {
      request_sent: false,
      code_data: null
    }
  })
}

export default function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./reducers/security-code.js